<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
              <b-card>
                <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                <form action="">
                  <div class="form-row mt-2">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                      <label for="report_type_id">Report Type</label>
                      <select v-model="search_data.report_type_id" v-validate="{ required: true }" class="form-control form-control-sm" name="report_type_id" id="report_type_id">
                        <option v-for="(report_type, index) in report_types" :key="index" :value="report_type.id">{{ report_type.id }} : {{ report_type.report_type_desc }}</option>
                      </select>
                    </div>
                  </div>
                  <button class="btn btn-success btn-sm mt-2" @click.prevent="search">
                    Search
                  </button>
                </form>
              </b-card>
                <b-card>
                    <div v-if="reports.length > 0" class="row mb-2">
                        <div class="col-md-12">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ reports.length }}</span>
                            <button type="button" id="export-table" @click="onexport"  class="btn btn-light float-right" style="margin-bottom:5px">Import to Excel</button>
                        </div>
                    </div>
                  <div class="table-responsive" style="overflow-x: auto">
                    <table class="table table-centered table-striped" id="titledExcel" >
                      <thead>
                      <tr>
                        <th>Sl</th>
                        <th>Title</th>
                        <th>File</th>
                        <th v-if="search_data.report_type_id == 1">Start Date</th>
                        <th v-if="search_data.report_type_id == 1">End Date</th>
                        <th v-if="search_data.report_type_id == 2">Month</th>
                        <th v-if="search_data.report_type_id == 2">Year</th>
                        <th v-if="search_data.report_type_id == 3">Year</th>
                        <th>Submission Date</th>
                        <th>Report Type</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(report, index) in reports" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ report.title }}</td>
                        <td>
                          <a :href="report.file" target="_blank">
                            {{ report.title }}
                          </a>
                        </td>
                        <td v-if="search_data.report_type_id == 1">{{ report.start_date }}</td>
                        <td v-if="search_data.report_type_id == 1">{{ report.end_date }}</td>
                        <td v-if="search_data.report_type_id == 2">{{ report.month }}</td>
                        <td v-if="search_data.report_type_id == 2">{{ report.month_year }}</td>
                        <td v-if="search_data.report_type_id == 3">{{ report.year }}</td>
                        <td>{{ report.submission_date }}</td>
                        <td>{{ report.report_type.report_type_desc }}</td>
                      </tr>
                      </tbody>
                    </table>
                    <h5 v-if="reports.length === 0 || !flag" class="text-center text-secondary">
                      No Data Found
                    </h5>
                  </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";
    import XLSX from 'xlsx';
    import months from "@views/asset/js/months"
    import years from "@views/asset/js/years"



    export default {
        page: {
            title: "Report List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Report List",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Report List",
                        active: true
                    }
                ],
                reports: [],
                report_types: [],
                months: months(),
                years: years(),
                search_data: {
                  report_type_id: '1'
                },
                btn_edit: false,
                flag: false,
                report_fields: {
                    'Title': 'title',
                    'Start date': 'start_date',
                    'End date': 'end_date',
                    'Submission Date': 'submission_date',
                    'Report Type': 'report_type.report_type_desc',
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
            };
        },

        mounted() {
          this.getCodes();
        },
        methods: {
          search() {
            this.$validator.validate().then(valid => {
              if (valid) {
                http.post("api/report/search", this.search_data).then(response => {
                  if (!response.error) {
                    this.flag = true
                    this.reports = response.data.reports;
                  }
                });
              }
            });
          },
          getCodes() {
            http.get("api/getReportCode").then(response => {
              if (!response.error) {
                let data = response.data;
                this.report_types = data.report_types;
              }
            });
          },
            onexport(evt) {
               var tbl = document.getElementById('titledExcel');
               var wb = XLSX.utils.table_to_book(tbl);
               XLSX.writeFile(wb, "report.xlsx");
          }
        },
    };
</script>
